import { render, staticRenderFns } from "./achievementStatistics.vue?vue&type=template&id=0587ab95&scoped=true"
import script from "./achievementStatistics.vue?vue&type=script&lang=js"
export * from "./achievementStatistics.vue?vue&type=script&lang=js"
import style0 from "./achievementStatistics.vue?vue&type=style&index=0&id=0587ab95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0587ab95",
  null
  
)

export default component.exports